import {Match} from "@/modules/match/entity";
import chance from "@/modules/base/services/chance";
import {injectable} from "inversify";
import AbstractMatchEvaluator from "./AbstractMatchEvaluator";
import {CardEnum, NeutralIncidentTypeEnum} from "@/modules/match/enums";

@injectable()
export default class RandomMatchEvaluator extends AbstractMatchEvaluator {
  async evaluate(match: Match): Promise<void> {
    await this.prepare(match);

    await this.createNeutralIncident(match, NeutralIncidentTypeEnum.START, 1);

    await match.homeTeam.load('players');
    await match.awayTeam.load('players');

    match.homeGoals = chance.integer({min: 0, max: 5});
    match.awayGoals = chance.integer({min: 0, max: 5});

    if (match.homeTeam.user) {
      match.homeGoals = Math.max(match.homeGoals, match.awayGoals);
    }

    if (match.awayTeam.user) {
      match.awayGoals = Math.max(match.homeGoals, match.awayGoals);
    }

    // goal incidents
    for (let i = 1; i <= match.homeGoals; i++) {
      await this.createGoalIncident(match, match.homeTeam, match.awayTeam);
    }

    for (let i = 1; i <= match.awayGoals; i++) {
      await this.createGoalIncident(match, match.awayTeam, match.homeTeam);
    }

    // card incidents
    for (let i = 1; i <= chance.integer({min: 1, max: 6}); i++) {
      const team = chance.bool() ? match.homeTeam : match.awayTeam;
      const player = chance.pickone(team.players.filter(p => p.lineup !== null));
      await this.createCardIncident(match, team, player, chance.randomEnum(CardEnum), this.getMinute());
    }

    // substitutions incidents
    // todo enable if needed
    if (false) {
      for (let i = 1; i <= chance.integer({min: 1, max: 3}); i++) {
        await this.createSubstituteIncident(match, match.homeTeam);
      }

      for (let i = 1; i <= chance.integer({min: 1, max: 3}); i++) {
        await this.createSubstituteIncident(match, match.awayTeam);
      }
    }

    // todo: use current minute
    await this.createNeutralIncident(match, NeutralIncidentTypeEnum.END, 96);

    await this.processResult(match);

    console.debug(`Match evaluated`, match);
  }
}